import { tw } from '@/utils/tw';
import BaseArticleDisclosureLabelTheme from 'base/components/ArticleDisclosureLabel/theme';

const ArticleDisclosureLabel = tw.theme({
  extend: BaseArticleDisclosureLabelTheme,
  base: ['text-headline-2xs', 'md:max-w-cols-10', 'lg:max-w-cols-9'],
});

export default ArticleDisclosureLabel;
